import { getProductSupplier } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const useSWRProductSupplier = (supplierId: string | null) => {
  const {
    data: supplier,
    isLoading,
    error,
    mutate,
  } = useSWR(supplierId ? `productSupplier-${supplierId}` : null, () => getProductSupplier(supplierId as string), {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });

  return {
    supplier,
    isLoading,
    error,
    refresh: () => mutate(),
  };
};

export default useSWRProductSupplier;
